import React from "react";
import Notification from "../components/Notifications/Notification";
export default function NotificationsPage() {
  return (
    <div className="page-layout">
      <Notification />
    </div>
  );
}
